import React from 'react';
import { TextInput } from '@gower/react-ui/components';
import { useStore } from '../../store';
import { NextFocus, prevent } from '@gower/react-ui/utils';

export type InputDelegationProps = {

};
export const InputDelegation: React.FC<InputDelegationProps> = ( { } ) => {

    const store = useStore();
    const readOnly = store.Status.isLoading || store.Status.isSaving || !store.canAddServices;
    const loading = false;
    const [value, setValue] = React.useState( '' );

    async function submit ( event ) {
        prevent( event );
        store.Request.setDelegation( value );
        if ( event ) {
            NextFocus( '* input, * textarea' );
        }
    };

    function clear () {
        store.Request.setDelegation( '' );
        setValue( '' );
    };

    React.useEffect( () => {
        const listener = () => { clear(); };
        store.on( 'reset', listener );
        return () => { store.removeListener( 'reset', listener ); };
    }, [] );

    return <>
        <TextInput
            prefix='Código Delegación:'
            placeholder="# # #"
            selectAllOnFocus
            numeric
            noDelayed
            large
            value={value}
            onChangeText={setValue}
            loading={loading}
            readOnly={readOnly}
            onEnterUp={submit}
            onEscapeUp={clear}
            onBlur={() => submit( null )}
        />
    </>;
};